import React from 'react'

const RightPage5 = () => {
  return (
    <div  id="Resume" className='px-6 py-12'>
        <h2 className="text-3xl font-bold text-black relative inline-block">
        Resume
        {/* Underline */}
        <span className="block w-10 h-1 bg-blue-400 mt-2"></span>
      </h2>   
       <p className="mt-4 text-gray-700  ">
        Great pains yield agreeable rewards. One must endure the consequences of their actions or escape something at all costs. Let them be sincere and genuine. Anyone may desire what others desire. And no one can prevent others from enjoying what belongs to them. Because they endure hardship in performing their duties, indeed even here they face difficulties.
        
      </p> 

      <div className="flex flex-col md:flex-row gap-8 pt-16">
  {/* Left Column */}
  <div className="md:w-1/2 space-y-8">
    {/* Summary */}
    <div>
      <h2 className="text-xl font-bold">Summary</h2>
      
      <p className="italic text-gray-700 pt-6">Innovative and results-driven Electrical Engineer with a solid foundation in designing, developing, and testing electrical systems and components. Skilled in circuit design, power distribution, and troubleshooting complex electrical issues. Strong problem-solving abilities and a commitment to delivering reliable and efficient solutions for diverse engineering projects.</p>
      <ul className="mt-2 space-y-1 text-sm">
        <li className='italic text-gray-700'>I-8 Islamabad</li>
        <li className='italic text-gray-700'>0316-0049-870</li>
        <li className='italic text-gray-700'>talalhaidermushtaq
@gmail.com</li>
      </ul>
    </div>
    {/* Education */}
    <div>
      <h2 className="pb-10 text-xl font-bold">Education</h2>
      {/* Degree Block */}
      <div className=" border-l-2 border-blue-500 pl-4 relative">
        <div className="absolute -left-3 top-0 w-4 h-4 bg-blue-500 rounded-full"></div>
        <h3 className="font-semibold">BS Electrical Engineering</h3>
        <p className=" italic">2020 - 2025</p>
        <p className=" italic">COMSATS University Islamabad, Pakistan</p>
        <p className=" text-gray-500">CGPA:2.22</p>
         <p className=" italic">Achievements</p>
         <p className=" text-gray-500">3rd Position in Robian Competition</p>

      </div>
      <div className="border-l-2 border-blue-500 pl-4 relative">
        <div className="absolute -left-3 top-0 w-4 h-4 bg-blue-500 rounded-full"></div>
        <h3 className="font-semibold">Matriculation</h3>
        <p className=" italic">2015 - 2017</p>
        <p className=" italic">Masali Zakria Secondary School for boys,Sheikhupura</p>
        <p className=" text-gray-500">Marks: 922/1100</p>
         <p className=" italic">Specialization</p>
         <p className=" text-gray-500">Science group</p>

      </div>
      <div className="border-l-2 border-blue-500 pl-4 relative">
        <div className="absolute -left-3 top-0 w-4 h-4 bg-blue-500 rounded-full"></div>
        <h3 className="font-semibold">Intermediate in Pre-Engineering</h3>
        <p className=" italic">2018 - 2020</p>
        <p className=" italic">Abdalian Science Higher Secondary School,Muzafargarh</p>
        <p className=" text-gray-500">Marks: 862/1100</p>
         
         

      </div>
      {/* More degrees... */}
    </div>
  </div>

  {/* Right Column */}
  <div className="md:w-1/2 space-y-8">
    <h2 className="text-xl font-bold">Professional Experience</h2>
    {/* Job Block */}
    <div className="border-l-2 border-blue-500 pl-4 relative">
      <div className="absolute -left-3 top-0 w-4 h-4 bg-blue-500 rounded-full"></div>
      <h3 className="font-semibold">Internee</h3>
      <p className=" italic">2022</p>
      <p className=" italic">National Transmittion AND DISPATCH COMPANY</p>
      <ul className="list-disc ml-4 text-sm">
        <li>Worked across 500 kV, 220 kV, and 132 kV switchyards and control rooms, supporting transmission system operations and maintenance. </li>
        <li>Designed and simulated electrical circuits and protection systems using LTSpice to verify performance before implementation.</li>
        <li>Developed detailed CAD drawings and schematics for transmission line layouts, substation equipment, and control panels.</li>
        <li>Conducted load flow and short-circuit studies, using simulation tools to ensure safe and reliable grid operation.</li>
        <li>Assisted in the selection and integration of electronic components for control and monitoring systems.</li>
      </ul>
    </div>
    {/* More jobs... */}
    <div className="border-l-2 border-blue-500 pl-4 relative">
      <div className="absolute -left-3 top-0 w-4 h-4 bg-blue-500 rounded-full"></div>
      <h3 className="font-semibold">Internee</h3>
      <p className=" italic">2023  (2 Months)</p>
      <p className=" italic">Internee Health Safety and Environment</p>
      <ul className="list-disc ml-4 text-sm">
        <li>Assisted the HSE team in implementing safety policies and procedures across work sites and substations.</li>
        <li>Conducted workplace inspections to identify hazards and ensure compliance with national safety standards.</li>
        <li>Supported risk assessments for electrical maintenance activities and high-voltage operations.</li>
        
      </ul>
    </div>
  </div>
</div>
  
    </div>
  )
}

export default RightPage5
